import { render, staticRenderFns } from "./BrickTimerDurationSettings.vue?vue&type=template&id=6ff9d29e&"
import script from "./BrickTimerDurationSettings.vue?vue&type=script&lang=js&"
export * from "./BrickTimerDurationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ff9d29e')) {
      api.createRecord('6ff9d29e', component.options)
    } else {
      api.reload('6ff9d29e', component.options)
    }
    module.hot.accept("./BrickTimerDurationSettings.vue?vue&type=template&id=6ff9d29e&", function () {
      api.rerender('6ff9d29e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Connection/BrickTimerDurationSettings.vue"
export default component.exports